export const APP_THEME_LIGHT = 'li';
export const APP_THEME_DARK = 'da';
